import { queryOptions, skipToken, useQuery } from '@tanstack/react-query'
import type { IAuthContext } from './useAuth'
import { useAuth } from './useAuth'

export const getLdfProducerGeoOptions = (
  auth: IAuthContext,
  prodnr: string | undefined
) => {
  return queryOptions({
    queryKey: ['ldfProducerGeo', prodnr],
    queryFn:
      prodnr && typeof auth.authFetch === 'function'
        ? async () => {
            const { data, error } = await auth
              .authFetch()
              .GET('/ldf/geo/prodnr/{prodnr}', {
                params: {
                  path: {
                    prodnr
                  }
                }
              })
            if (error) {
              return []
            }
            return data ?? []
          }
        : skipToken,
    staleTime: 5 * 60 * 1000
  })
}

export const useLdfProducerGeo = (prodnr: string | undefined) => {
  const auth = useAuth()
  return useQuery(getLdfProducerGeoOptions(auth, prodnr))
}
